// Props envoyées à Umami par le controller `track`. Avec `withChecked`, l'état de la
// case qui a déclenché l'évènement est ajouté (`checked`) : sur une case cochée par
// défaut, sans lui un clic de décochage et un clic de cochage sont indiscernables.
// Avec `withValue`, la valeur du <select> qui a déclenché l'évènement est ajoutée
// (`value`) : sans elle, un changement de langue ou de choix ne dit pas lequel.
// Sans évènement (tracé au connect / à la visibilité) ou hors de ces champs, les
// props restent celles du data-attribute.
export function trackProps(props, event, withChecked, withValue = false) {
  const target = event?.target
  if (withChecked && target?.type === "checkbox") return { ...props, checked: target.checked }
  if (withValue && target?.tagName === "SELECT") return { ...props, value: target.value }
  return props
}
